/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowUpToDottedLine: {
  name: 'arrow-up-to-dotted-line';
  data: string;
} = {
  name: 'arrow-up-to-dotted-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm6 14v-7.586l2.293 2.293a1 1 0 0 0 1.414-1.414l-4-4a1 1 0 0 0-1.414 0l-4 4a1 1 0 1 0 1.414 1.414L11 11.414V19a1 1 0 1 0 2 0ZM10 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
